  <!-- ======= Header ======= -->
<header id="header" class="header fixed-top d-flex align-items-center">

  <div class="d-flex align-items-center justify-content-between">
    <a [routerLink]="['/']" class="logo d-flex align-items-center">
      <img src="assets/img/Rank Ahead.png" alt="rank ahead">
      <span class="d-none d-lg-block">Rank Ahead</span>
    </a>
    <i class="bi bi-list toggle-sidebar-btn" (click)="onSidebarToggleClicked()" *ngIf="showToggle"></i>
  </div><!-- End Logo -->

  <nav class="header-nav ms-auto">
    <ul class="d-flex align-items-center">

      <!--<li class="nav-item pe-3">
        <a [routerLink]="['/manage-sites']">
          <span>Manage Sites</span>
        </a>
      </li>-->
      <li class="nav-item pe-3 hide-on-mobile">
        <a [routerLink]="['/blog']" class="showPointer">
          <span class="nav-item-text">Blog</span>
        </a>
      </li>
      <li class="nav-item pe-3 hide-on-mobile">
        <a [routerLink]="['/faq']" class="showPointer">
          <span class="nav-item-text">FAQ</span>
        </a>
      </li>
      <li class="nav-item pe-3">
        <a [routerLink]="['/pricing']" class="showPointer">
          <span class="nav-item-text">Pricing</span>
        </a>
      </li>
      <li class="nav-item pe-3" *ngIf="user!=undefined && isPathCorrect">
        <a [routerLink]="['/manage-sites']" class="showPointer">
          <span class="nav-item-text">Manage Sites</span>
        </a>
      </li>
      <li class="nav-item pe-3" *ngIf="user==undefined">
        <!--<a [routerLink]="['/signin']">
          <span class="nav-item-text">Signin</span>
        </a>-->
        <button type="button" class="btn btn-primary" [routerLink]="['/signin']" style="cursor:pointer!important">Signin</button>
      </li>
      <li class="nav-item dropdown pe-3" *ngIf="user!=undefined">
        <!--<asl-google-signin-button *ngIf="user==undefined" type="standard" text="signin_with" size="large"></asl-google-signin-button>-->
        <a class="showPointer nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
          <img src="{{ user?.photoUrl }}" alt="Profile" class="rounded-circle">
          <span class="d-none d-md-block dropdown-toggle ps-2">{{ user?.name }}</span>
        </a>
        <!--End Profile Iamge Icon-->
        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li class="dropdown-header">
            <h6>{{ user?.name }}</h6>
            <!--<span>Web Designer</span>-->
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>

          <li>
            <hr class="dropdown-divider">
          </li>

          <li>
            <a class="showPointer dropdown-item d-flex align-items-center" [routerLink]="['/account-settings']">
              <i class="bi bi-gear"></i>
              <span>Account Settings</span>
            </a>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>

          <li>
            <hr class="dropdown-divider">
          </li>

          <li>
            <a class="showPointer dropdown-item d-flex align-items-center showPointer" (click)="signOut()">
              <i class="bi bi-box-arrow-right"></i>
              <span>Sign Out</span>
            </a>
          </li>
        </ul>
        <!-- End Profile Dropdown Items -->
      </li><!-- End Profile Nav -->
    </ul>
  </nav><!-- End Icons Navigation -->
</header><!-- End Header -->
